import * as React from "react";

export const ScalesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M14.167 17.5H5.833A3.333 3.333 0 0 1 2.5 14.167V5.833A3.333 3.333 0 0 1 5.833 2.5h8.334A3.333 3.333 0 0 1 17.5 5.833v8.334a3.333 3.333 0 0 1-3.333 3.333"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m2.5 12.5 5.833-4.167 3.334 3.334L17.5 7.5"
    ></path>
  </svg>
);
